import { format, zonedTimeToUtc } from 'date-fns-tz';

/* Note: copied utility functions as is from angular reporting service
   may require some modifications while consuming API's   */
export function getAPIDateFormat({ ISOStartDateString }) {
  const formatTimeToUTC = zonedTimeToUtc(ISOStartDateString);
  return format(formatTimeToUTC, 'yyyyMMdd000000');
}

export function getAPIEndDateFormat({ ISOEndDateString }) {
  const formatTimeToUTC = zonedTimeToUtc(ISOEndDateString);
  return format(formatTimeToUTC, 'yyyyMMdd235959');
}

export function formatApiDateRange({ dateRange }) {
  let dateRangeString = '';
  if (!dateRange) {
    const tmpDate = new Date();
    // eslint-disable-next-line no-magic-numbers
    dateRange = { start: new Date(new Date().setDate(tmpDate.getDate() - 30)), end: tmpDate };
  }

  dateRangeString += getAPIDateFormat({ ISOStartDateString: dateRange.start });
  dateRangeString += '=>';
  dateRangeString += getAPIEndDateFormat({ ISOEndDateString: dateRange.end });

  return dateRangeString;
}
